import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Constants } from "../constants/constants";
import { HttpClient } from "../authentication/httpClient";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

@Injectable()
export class ManagerManagementService {

	constructor(private http: HttpClient) {}

	getManagerManagement(): Observable<Array<IManagerManagement>> {
		return this.http.get(`${Constants.restUrl}ManagerManagement/GetManagerManagement`).map((res: Response) => res.json()).catch(this.handleError);
    }

    saveManager(manager: IManagerManagement) {
		return this.http.put(`${Constants.restUrl}Manager/UpdateManager`, manager).map((res: Response) => res.json()).catch(this.handleError);
    }

    addManager(manager: IManagerManagement) {
		return this.http.post(`${Constants.restUrl}Manager/AddManager`, manager).map((res: Response) => res.json()).catch(this.handleError);
    }

	getManagerByEmail(email: string): Observable<IManagerModel> {
		return this.http.get(`${Constants.restUrl}ManagerManagement/GetManagerByEmail/${email}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	private handleError(error: any): Observable<any> {
		console.error("An error occurred", error);
		return Observable.throw(error.message || error);
	}
}